import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { JUKE_PATH_A } from '@constant'

export default class extends Component {
  render() {
    let header = [<a href={JUKE_PATH_A}>聚客宝</a>, '活动点说明']
    return (
      <HeaderView title="活动点说明" header={header}>
        <ul className={styles.box}>
          <li>
            <h3>
              <i />什么是活动点？
            </h3>
            <p>
              活动点是用于商家活动报名中查看用户联系方式需消耗的点数。活动点无使用期限，无活动场次要求。
            </p>
          </li>
          <li>
            <h3>
              <i />活动点如何充值？
            </h3>
            <p>
              商家可在活动管理中点击【充值】按钮，选择需要充值的点数后通过账户余额或银行卡进行支付充值。
            </p>
          </li>
          <li>
            <h3>
              <i />活动点如何使用？
            </h3>
            <p style={{ paddingBottom: 6 }}>
              商家申请活动后会进行活动审核，审核通过最终上线的活动，会有用户报名参加，在活动结束后，商家若需要查看报名用户联系方式
              则需要消耗活动点，查看一个报名用户需消耗一个活动点。
            </p>
            <p style={{ paddingBottom: 6 }}>
              <em>消耗活动点=报名用户数-重复报名用户数</em>
            </p>
            <p>
              重复报名用户：指该用户参加了商家A活动，且商家在A活动中消耗了一个活动点查看该用户；之后该用户又参加了商家后期的B活动，
              此时该用户则属于重复报名用户。
            </p>
          </li>
          <li style={{ borderBottom: 0 }}>
            <h3>
              <i />活动点若没有消耗完，可否退返折现？
            </h3>
            <p>不退返折现。活动点可不限时间与活动次数使用。</p>
          </li>
        </ul>
      </HeaderView>
    )
  }
}
